const LOGIN_REQUSTED = 'LOGIN_REQUSTED';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_ERROR = 'LOGIN_ERROR';
const LOGIN_OUT = 'LOGIN_OUT';

const USER_REQESTED = 'USER_REQESTED';
const USER_REQUEST_DATA = 'USER_REQUEST_DATA';

const CROPPER_ADD_PHOTO = 'CROPPER_ADD_PHOTO';
const CROPPER_ZOOM_PHOTO = 'CROPPER_ZOOM_PHOTO';

const MODAL_WINDOW = 'MODAL_WINDOW';
const POPPER_SHOW = 'POPPER_IS_SHOW';

const COORDINATES_REQUESTED = 'COORDINATES_REQUESTED';
const SET_MAP_COORDINATES = 'SET_MAP_COORDINATES';
const SET_POSITION_CENTER_MAP = 'SET_POSITION_CENTER_MAP';
const SET_ERROR_MAP_COORDINATES = 'SET_ERROR_MAP_COORDINATES';
const SET_MAP_ID = 'SET_MAP_ID';
const DELETE_MAP_COORDINATES = 'DELETE_MAP_COORDINATES';

const GALLERY_FETCH_REQUESTED = 'GALLERY_FETCH_REQUESTED';
const SET_PHOTO_GALLERY = 'SET_PHOTO_GALLERY';
const REMOVE_ITEM_GALLERY = 'REMOVE_ITEM_GALLERY';

const SET_NOTICE = 'SET_NOTIFICATION';

const SET_NEW_THEME = 'SET_THEME';
const GET_THEME = 'GET_THEME';

export {
  LOGIN_REQUSTED,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_OUT,
  USER_REQESTED,
  USER_REQUEST_DATA,
  CROPPER_ADD_PHOTO,
  CROPPER_ZOOM_PHOTO,
  MODAL_WINDOW,
  POPPER_SHOW,
  COORDINATES_REQUESTED,
  SET_MAP_COORDINATES,
  SET_POSITION_CENTER_MAP,
  SET_ERROR_MAP_COORDINATES,
  DELETE_MAP_COORDINATES,
  SET_MAP_ID,
  GALLERY_FETCH_REQUESTED,
  SET_PHOTO_GALLERY,
  REMOVE_ITEM_GALLERY,
  SET_NOTICE,
  SET_NEW_THEME,
  GET_THEME
}